// extracted by mini-css-extract-plugin
module.exports = {"item":"menu-item_item__qdbWL","link":"menu-item_link__5nAhV","_active":"menu-item__active__oXesK"};